const asideWidth = 480;
const textColor = {
  primary: '#202020', // #353535
  secondary: '#707070',
  disabled: '#a09abb',
  grayColor: '#808080', // #a5a5a5
  grayColor1: '#C1C1C1',
  grayColor2: '#F2F2F1',
  grayColor3: '#9D9993',
  grayColor4: '#846E6C',
  danger1: 'red',
  third: '#767676',
};
const secondaryColor = {
  light: textColor.grayColor,
  main: '#262544',
  dark: textColor.primary,
  contrastText: '#fff',
};
const bg = {
  separator: '#dbdbdb',
  transparent: 'transparent',
  whiteOff1: '#f2f2f2',
  whiteOff2: '#dbdbdb',
  whiteOff3: '#f9f3f5',
  whiteOff4: '#fbfbfb',
  white: '#ffffff',
  black: '#000000',
  sidebar: '#DFDBD6',
  sidebarHover: '#F3F1F0',
};
const border = {
  light: '#dbdbdb',
  lighter: '#f1f1f1',
  dark: '#c0c0c0',
};
const socialMediaColor = {
  facebook: '#355087',
  linkedin: '#0077B3',
  google: '#D94437',
};
const otherColor = {
  success: '#277D43',
  successLight: 'rgba(0, 201, 87,0.1)',
  successMid: 'rgba(0, 201, 87,0.5)',
  successDark: '#c62306',
  warn: '#FFB018',
  warnLight: '#FFF7E7',
  warning2: '#FFBF3F',
  warnMid: 'rgba(255, 176, 24, 0.5)',
  info: '#2196F3',
  infoLight: 'rgba(211, 234, 253, 1)',
  infoMid: 'rgba(104, 107, 255, 0.5)',
  danger: '#F83E1D',
  dangerLight: 'rgba(248, 62, 29, 0.1)',
  dangerMid: 'rgba(248, 62, 29, 0.5)',
  dangerDark: '#008037',
  yellowLight: 'rgba(255, 176, 24, 0.1)',
  yellow: 'rgba(255, 176, 24, 1)',
  greenLight: 'rgba(39, 194, 76, 0.1)',
  green: 'rgba(39, 194, 76, 1)',
  inputDisableBg: '#F5F5F5',
  checkBoxDisable: 'rgba(0, 0, 0, 0.26)',
  warn2Bg: 'rgba(251, 179, 73, 0.2)',
  warn2: '#FBB349',
  success2Bg: 'rgba(40, 196, 113, 0.2)',
  success2: '#28C471',
  danger2: '#F27170',
  tagbg_magenta: '#dfd4f7',
  tag_magenta: '#604c8c',
  tagbg_green: '#d9f7e7',
  tag_green: '#3D8A61',
  tagbg_orange: '#fde1b6',
  tag_orange: '#EE8C46',
  tagbg_gray: '#e0e0e0',
  tag_gray: '#727272',
  tagbg_red: '#ffedea',
  tag_red: '#DD8D8C',
  tagbg_yellow: '#ffedb3',
  tag_yellow: '#d09c34',
  tagbg_pink: '#ffeeed',
  tag_pink: '#e39982',
  alertWarnBg: '#FEF5F3',
  alertWarnText: '#353535',
  black: '#000000',
  warn2Light: '#FEF3E3',
  logoColor: '#191515'
};
const breakpoints = {
  xl: 1440,
  lg: 1104,
  md: 960,
  sm: 600,
  xs: 0,
};
const zIndex = {
  dashHeader: 99,
  modal: 1200,
};


const fontSize = {
  size1: '4rem', // 64px
  size2: '2.5rem', // = 40px
  size3: '2rem', // = 32px
  size4: '1.5rem', // = 24px
  size5: '1.25rem', // = 20px
  size6: '1.125rem', // = 18px
  size7: '1rem', // = 16px
  size8: '0.875rem', // = 14px
  size9: '0.75rem', // = 12px
};

const fontWeight = {
  regular: 400,
  bold: 700,
  semiBold: 600,
};
const borderRadius = 0;

export default function createThemeSettings({ primaryColor, TypofontFamily = 'Libre Franklin', HeaderfontFamily = "Arvo", backgroundDefault }) {
  const inputBoxShadow = `0 0 0 1px ${primaryColor.main}, 0 0 0 5px rgba(${primaryColor.mainRgb.r}, ${primaryColor.mainRgb.g}, ${primaryColor.mainRgb.b}, 0.2)`;

  return {
    props: {
      MuiButtonBase: {
        disableRipple: true,
        // disabledTouchRipple: true
      },
    },
    breakpoints: {
      values: breakpoints,
    },
    typography: {
      fontFamily: [TypofontFamily, '-apple-system', '"Montserrat"', 'Arial', 'sans-serif'].join(','),
      h1: {
        fontSize: fontSize.size1,
        fontWeight: fontWeight.bold,
        fontFamily: TypofontFamily,
      },
      h2: {
        fontSize: fontSize.size2,
        fontWeight: fontWeight.bold,
        fontFamily: TypofontFamily,
      },
      h3: {
        fontSize: fontSize.size3,
        fontWeight: fontWeight.bold,
        fontFamily: TypofontFamily,
      },
      h4: {
        fontSize: fontSize.size4,
        fontWeight: fontWeight.bold,
        fontFamily: TypofontFamily,
      },
      h5: {
        fontSize: fontSize.size5,
        fontWeight: fontWeight.bold,
        fontFamily: TypofontFamily,
      },
      h6: {
        fontSize: fontSize.size6,
        fontWeight: fontWeight.bold,
        fontFamily: TypofontFamily,
      },
      subtitle1: {
        fontSize: fontSize.size7,
        fontWeight: fontWeight.bold,
        fontFamily: TypofontFamily,
      },
      subtitle2: {
        fontSize: fontSize.size7,
        fontWeight: fontWeight.regular,
        fontFamily: TypofontFamily,
      },
      body2: {
        fontSize: fontSize.size8,
        fontWeight: fontWeight.regular,
        fontFamily: TypofontFamily,
      },
      body1: {
        fontSize: fontSize.size8,
        fontWeight: fontWeight.semiBold,
        fontFamily: TypofontFamily,
      },
      caption: {
        fontSize: fontSize.size9,
        fontFamily: TypofontFamily,
      },
    },
    palette: {
      primary: primaryColor,
      secondary: secondaryColor,
      text: textColor,
      bg,
      ...(backgroundDefault ? { background: { default: backgroundDefault } } : {}),
      grey: {
        main: '#ffffff',
      },
      error: {
        main: '#CC2B2B',
      },
      success: {
        main: '#277D43',
      },
      warning: {
        main: '#FADD21',
      },
      info: {
        main: '#4DADCA',
      },
      socialMediaColor,
      border,
      alert: otherColor,
    },
    inputBoxShadow,
    fontSize,
    shape: {
      borderRadius,
    },
    asideWidth,
    zIndex,
    shadows: ['none', 'none', '0 4px 10px 0 #DCDCDA, 0 2px 6px 0 #F2F2F1'],
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '*, *::before, *::after': {
            boxSizing: 'border-box',
          },
          '@media screen and (max-width: 960px)': {
            html: {
              fontSize: '90%',
            },
          },
        },
      },
      MuiIconButton: {
        root: {
          '&.square': {
            borderRadius: 0,
          },
        },
        colorPrimary: {
          color: 'var(--vpro-primary-main)',
        },
      },
      MuiRadio: {
        colorPrimary: {
          color: 'var(--vpro-primary-main)',
        },
      },
      MuiButton: {
        root: {
          fontWeight: fontWeight.bold,
          boxShadow: 'none',
          textTransform: 'inherit',
          fontFamily: HeaderfontFamily,
          whiteSpace: 'nowrap',
          '&.uppercase': {
            // textTransform: 'uppercase',
          },
          borderRadius: 20,
        },
        sizeSmall: {
          borderRadius: 20,
        },
        sizeLarge: {
          fontSize: fontSize.size8,
          paddingTop: 9.5,
          paddingBottom: 9.5,
        },
        sizeMedium: {
          fontSize: fontSize.size8,
          borderRadius: 20,
          paddingTop: 12,
          paddingBottom: 9,
        },
        textSizeSmall: {
          paddingTop: 5,
          paddingBottom: 5,
          paddingLeft: 16,
          paddingRight: 16,
        },
        contained: {
          boxShadow: 'none',
          '&.rounded': {
            paddingLeft: 16,
            paddingRight: 16,
            minWidth: 40,
            minHeight: 40,
            borderRadius: 40,
          },
          '&.squarebtn': {
            borderRadius: '50%',
            height: 32,
            width: 32,
            minWidth: 32,
            padding: 0,
          },
          '&.Mui-disabled': {
            cursor: 'not-allowed !important',
            background: `#DFDBD6 !important`,
            backgroundColor: `#DFDBD6 !important`,
            transition: 'none',
            color: textColor.secondary,
          },
          '&:hover': {
            backgroundColor: 'red',
          },
        },
        containedSizeSmall: {
          paddingTop: 5,
          paddingBottom: 5,
          paddingLeft: 16,
          paddingRight: 16,
          '&.rounded': {
            paddingLeft: 16,
            paddingRight: 16,
            minWidth: 32,
            minHeight: 32,
            borderRadius: 32,
          },
          '&.square': {
            paddingLeft: 8,
            paddingRight: 8,
            minWidth: 30,
            minHeight: 30,
            borderRadius,
          },
        },
        containedSizeLarge: {
          borderRadius: 44,
          '&.rounded': {
            paddingLeft: 16,
            paddingRight: 16,
            minWidth: 44,
            minHeight: 44,
            borderRadius: 44,
          },
        },
        outlined: {
          background: bg.white,
          borderRadius: 24,
          '&.square': {
            paddingLeft: 6,
            paddingRight: 6,
            minWidth: 40,
            minHeight: 40,
            borderRadius: '50%',
          },
          '&.rounded': {
            paddingLeft: 12,
            paddingRight: 12,
            minWidth: 40,
            minHeight: 40,
            borderRadius: 40,
          },
          '&:hover': {
            backgroundColor: bg.white,
          },
        },
        outlinedSizeSmall: {
          paddingLeft: 16,
          paddingRight: 16,
          '&.square': {
            paddingLeft: 4,
            paddingRight: 4,
            minWidth: 32,
            minHeight: 32,
            borderRadius: '50%',
            border: 'none',
            backgroundColor: `#F2F2F1`,
            color: textColor.primary,
            '& svg': {
              color: textColor.primary,
              height: 18,
              width: 18,
            },
            '&:hover': {
              backgroundColor: `#F2F2F1`,
              color: textColor.primary,
            },
          },
          '&.rounded': {
            paddingLeft: 16,
            paddingRight: 16,
            minWidth: 32,
            minHeight: 32,
            borderRadius: 32,
          },
        },
        outlinedSizeLarge: {
          '&.rounded': {
            borderRadius: 44,
            paddingLeft: 16,
            paddingRight: 16,
          },
          '&.square': {
            paddingLeft: 9.5,
            paddingRight: 9.5,
            minWidth: 44,
            minHeight: 44,
            borderRadius,
          },
        },
        outlinedPrimary: {
          backgroundColor: `#F2F2F1`,
          borderColor: `#F2F2F1`,
          color: textColor.primary,
          '&:hover': {
            backgroundColor: `#F2F2F1`,
            borderColor: `#F2F2F1`,
            boxShadow: 'none',
            color: textColor.primary,
          },
        },
        outlinedSecondary: {
          background: secondaryColor.main,
          color: '#fff',
          paddingLeft: 16,
          paddingRight: 16,
          minWidth: 32,
          minHeight: 32,
          border: 'none',
          borderRadius: 16,
          '&:hover': {
            backgroundColor: secondaryColor.main,
            color: '#fff',
            border: 'none',
          },
          '&:disabled': {
            cursor: 'not-allowed !important',
            background: `#DFDBD6 !important`,
            backgroundColor: `#DFDBD6 !important`,
            transition: 'none',
            color: textColor.secondary,
          },
        },
        containedPrimary: {
          backgroundColor: 'var(--vpro-primary-main)',
          '&:focus': {
            outline: `2px solid var(--vpro-primary-main)`, // blue outline: ;
            outlineOffset: '2px',
          },
          '&:hover': {
            backgroundColor: 'var(--vpro-primary-dark)',
          },
        },
        containedSecondary: {
          backgroundColor: `#F2F2F1`,
          boxShadow: 'none',
          color: textColor.primary,
          '&:focus': {
            outline: `2px solid ${textColor.primary}`, // blue outline: ;
            outlineOffset: '2px',
          },
          '&.square': {
            paddingLeft: 4,
            paddingRight: 4,
            minWidth: 30,
            minHeight: 30,
            borderRadius,
          },
          '&:hover': {
            backgroundColor: `#E3E0DE`,
          },
        },
        textPrimary: {
          color: 'var(--vpro-primary-main)',
        },
      },
      MuiDivider: {
        root: {
          backgroundColor: bg.separator,
        },
      },
      MuiTableCell: {
        root: {
          fontFamily: TypofontFamily,
          fontSize: fontSize.size8,
          borderBottom: 'none',
          '&.fixedC': {
            position: 'sticky',
            top: 'auto',
            zIndex: 10,
            '&.left': {
              left: 0,
              boxShadow: `inset -12px 0 4px -11px rgb(0 0 0 / 20%)`,
            },
            '&.right': {
              right: 0,
              boxShadow: `inset 4px 0 6px -7px rgb(0 0 0 / 70%)`,
            },
          },
        },
        head: {
          textTransform: 'uppercase',
          fontSize: fontSize.size12,
          color: textColor.primary,
          lineHeight: '1.95rem',
          whiteSpace: 'nowrap',
          fontWeight: 500,
          padding: '1rem 1rem',
          '&.fixedC': {
            background: bg.sidebarHover,
            '&.fixedHead': {
              top: 0,
              zIndex: 11,
            },
          },

          '@media screen and (max-width: 960px)': {
            padding: '10px 14px',
          },
        },
        body: {
          padding: '14px 16px',
          position: 'relative',
          '@media screen and (max-width: 960px)': {
            padding: '10px 14px',
          },
          '& .MuiTypography-caption': {
            fontSize: `${fontSize.size8}`,
          },
          '&.fixedC': {
            background: bg.white,
          },
        },
      },
      MuiSlider: {
        root: {
          '& .MuiSlider-track': {
            backgroundColor: primaryColor.main,
          },
        },
      },
      MuiCheckbox: {
        root: {
          color: 'var(--vpro-primary-main)',
          fontFamily: TypofontFamily,
        },
        indeterminate: {
          color: 'var(--vpro-primary-light)',
        },
        colorPrimary: {
          color: textColor.grayColor1,
          '&:hover': {
            backgroundColor: 'var(--vpro-primary-extraLight) !important',
          },
          '&.Mui-checked': {
            color: 'var(--vpro-primary-main)',
            '&:hover': {
              backgroundColor: 'var(--vpro-primary-extraLight) !important',
            },
          },
          '&.Mui-disabled': {
            color: otherColor.checkBoxDisable,
          },
        },
      },
      MuiTableRow: {
        root: {
          fontFamily: TypofontFamily,
          '&.MuiTableRow-hover': {
            '&:hover': {
              backgroundColor: bg.whiteOff4,
            },
          },
          '&.Mui-selected': {
            backgroundColor: primaryColor.extraLight,
            '&:hover': {
              background: 'none',
            },
          },
        },
      },
      MuiFormLabel: {
        root: {
          fontSize: fontSize.size9,
          color: textColor.secondary,
          textTransform: 'capitalize',
          fontFamily: TypofontFamily,
          fontWeight: 400,
          '&.Mui-focused': {
            color: textColor.secondary,
          },
        },
      },
      MuiList: {
        root: {
          '&.disabled': {
            '& .MuiListItem-root': {
              background: 'transparent !important',
            },
          },
        },
      },
      MuiListItem: {
        root: {
          fontWeight: 500,
          '&.Mui-disabled': {
            opacity: 1,
          },
          '&.disabledHover': {
            '&:hover': {
              background: 'transparent',
            },
          },
          '& .MuiListItemText-root': {
            color: textColor.primary,
          },
          '&.Mui-selected': {
            background: bg.whiteOff1,
          },
          '& .MuiListItemIcon-root': {
            color: textColor.primary,
          },
          '&:hover': {
            background: bg.whiteOff1,
          },
        },
      },
      MuiLinearProgress: {
        root: {
          borderRadius: 0,
          fontFamily: TypofontFamily,
          '&.green': {
            backgroundColor: bg.whiteOff2,
            '& .MuiLinearProgress-bar': {
              borderRadius: 0,
              backgroundColor: otherColor.success2,
            },
          },
        },
      },
      MuiInputLabel: {
        root: {
          fontFamily: TypofontFamily,
          fontSize: fontSize.size9,
        },
        shrink: {
          transform: `translate(0, 0) scale(1)`,
        },
        asterisk: {
          color: textColor.danger1,
        },
      },
      MuiInputAdornment: {
        root: {
          fontFamily: TypofontFamily,
          height: 'auto',
          '&.btn-adornment, &.icon-adornment': {
            width: 24,
          },
        },
        positionStart: {
          marginRight: `calc(8px)`,
        },
        positionEnd: {
          marginLeft: `calc(8px)`,
        },
      },
      MuiInputBase: {
        root: {
          backgroundColor: bg.white,
          border: `1px solid #c0c0c0`,
          fontFamily: TypofontFamily,
          borderRadius: 0,
          transition: `color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
          '& .MuiInputAdornment-root': {
            color: textColor.grayColor1,
            transition: `color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
            '& svg': {
              maxWidth: 18,
              maxHeight: 18,
            },
          },
          '&.read-only': {
            '& input': {
              color: textColor.secondary,
            },
          },
          '&[data-size=small] .MuiInputAdornment-root svg': {
            width: 18,
            height: 18,
          },
          '&:focus': {
            outline: 0,
          },
          '&.Mui-focused': {
            borderColor: 'transparent',
            boxShadow: inputBoxShadow,
          },
        },
        input: {
          boxSizing: 'content-box !important',
          fontSize: fontSize.size8,
          fontWeight: fontWeight.regular,
          color: textColor.primary,
          '&::-webkit-input-placeholder': {
            color: textColor.grayColor,
            opacity: 1,
          },
          '&::-moz-placeholder': {
            color: textColor.grayColor,
            opacity: 1,
          },
          '&:-moz-placeholder': {
            color: textColor.grayColor,
            opacity: 1,
          },
          '&&:-ms-input-placeholder': {
            color: textColor.grayColor,
            opacity: 1,
          },
          '&:placeholder': {
            color: textColor.grayColor,
            opacity: 1,
          },
        },
      },
      MuiSelect: {
        select: {
          borderRadius,
          fontFamily: TypofontFamily,
          backgroundColor: bg.whiteOff1,
          '&.Mui-disabled': {
            cursor: 'not-allowed',
          },
          '&:focus': {
            backgroundColor: bg.whiteOff1,
          },
        },
      },
      MuiMenuItem: {
        root: {
          minHeight: 40,
          fontFamily: TypofontFamily,
          color: textColor.primary,
          paddingTop: 9.5,
          paddingBottom: 9.5,
          fontWeight: 500,
          '&:hover': {
            backgroundColor: bg.whiteOff1,
            color: textColor.primary,
          },
          '&.Mui-selected': {
            backgroundColor: bg.whiteOff1,
            color: textColor.primary,
            '&:hover': {
              backgroundColor: bg.whiteOff1,
              color: textColor.primary,
            },
          },
        },
      },
      MuiFormControlLabel: {
        root: {
          fontFamily: TypofontFamily,
          '&.Mui-disabled': {
            color: textColor.disabled,
            cursor: 'not-allowed',
          },
        },
        label: {
          '&.Mui-disabled': {
            color: textColor.disabled,
            cursor: 'not-allowed',
          },
          '&.MuiTypography-root.Mui-disabled': {
            color: textColor.disabled,
          },
        },
      },
      MuiButtonBase: {
        disableRipple: true,
        root: {
          fontFamily: TypofontFamily,
          '&.Mui-disabled': {
            cursor: 'not-allowed',
          },
        },
      },
      MuiAppBar: {
        root: {
          fontFamily: TypofontFamily,
          '&.custom-app-bar': {
            backgroundColor: 'transparent',
            boxShadow: 'none !important',
          },
          '& .MuiTabs-scrollButtons:first-child': {
            marginLeft: -40,
          },
          '& .MuiTabs-scrollButtons:last-child': {
            marginRight: -40,
          },
        },
      },
      MuiTabs: {
        root: {
          minHeight: 40,
          fontFamily: TypofontFamily,
          // borderBottom: `1px solid ${border.light} `,
          '&.tabs-style-3': {
            '& .MuiTabs-flexContainer': {
              gap: '2rem',
            },
            '& .MuiTab-root': {
              padding: '10px 0px',
            },
          },
          '&.tabs-style-2': {
            '& .MuiTabScrollButton-root': {
              // opacity: 1,
              cursor: 'pointer',
              '&.Mui-disabled': {
                width: 0,
              },
            },
            borderBottom: `1px solid transparent`,
            '& .MuiTabs-scroller': {
              border: `1px solid ${bg.whiteOff2}`,
              borderRadius: 0,
              backgroundColor: bg.whiteOff4,
              // display: 'flex',
              '& .MuiTab-root': {
                fontSize: 14,
                minHeight: 36,
                padding: '7px 10.5px',
                color: textColor.primary,
                textTransform: 'capitalize',
                // borderRight: '1px solid ' + bg.whiteOff2,
                '&:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: 'transparent',
              },
              '& .Mui-selected': {
                backgroundColor: primaryColor.main,
                // boxShadow: '4px 4px 12px #0000001A',
                borderColor: 'transparent',
                color: primaryColor.contrastText,
                '& .MuiBox-root': {
                  color: primaryColor.contrastText,
                },
              },
            },
          },
          '&.tabs-style-4': {
            '& .MuiTabScrollButton-root': {
              // opacity: 1,
              cursor: 'pointer',
              '&.Mui-disabled': {
                width: 0,
              },
            },
            borderBottom: `1px solid transparent`,
            '& .MuiTabs-scroller': {
              border: `1px solid ${bg.whiteOff2}`,
              borderRadius: '0rem',
              backgroundColor: textColor.grayColor2,
              // display: 'flex',
              '& .MuiTab-root': {
                fontSize: 14,
                minHeight: 36,
                padding: '7px 10.5px',
                borderRadius: '0rem',
                textTransform: 'capitalize',
                // borderRight: '1px solid ' + bg.whiteOff2,
                '&:last-child': {
                  borderRight: 'none',
                },
                '& .MuiTab-wrapper': {
                  fontWeight: 600,
                },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: 'transparent',
              },
              '& .Mui-selected': {
                backgroundColor: primaryColor.main,
                // boxShadow: '4px 4px 12px #0000001A',
                borderColor: 'transparent',
                color: primaryColor.contrastText,
                '& .MuiBox-root': {
                  color: primaryColor.contrastText,
                },
                '& .MuiTab-wrapper': {
                  color: primaryColor.contrastText,
                },
              },
            },
          },
        },
        vertical: {
          borderBottom: 0,
          '& .MuiTabs-scroller': {
            zIndex: 0,
          },
          '& .MuiTabs-indicator': {
            backgroundColor: bg.whiteOff1,
            width: 'auto',
            left: 0,
            borderRadius: 0,
            zIndex: -1,
          },
          '& .MuiTab-root': {
            padding: `calc(8px * 1) calc(8px * 1.5)`,
            borderRadius: 0,
            transition: 'background-color 0.3s ease',
            backgroundColor: 'transparent',
            '& + .MuiTab-root': {
              marginTop: `calc(8px * 1)`,
            },
            '&:hover': {
              // backgroundColor: bg.whiteOff1,
              color: textColor.primary,
            },
            '&.Mui-selected': {
              '& .MuiTab-wrapper': {
                color: textColor.primary,
              },
            },
            '&.Mui-selected:hover': {
              color: textColor.primary,
            },
          },
          '& .MuiTab-wrapper': {
            textAlign: 'left',
            alignItems: 'flex-start',
            transition: 'color 0.3s ease',
            color: textColor.primary,
          },
        },
        indicator: {
          // backgroundColor: primaryColor.main,
          height: 4,
        },
      },
      MuiTab: {
        root: {
          color: textColor.secondary,
          minWidth: 100,
          minHeight: 40,
          fontFamily: TypofontFamily,
          textTransform: 'initial',
          fontWeight: fontWeight.bold,
          padding: '8px 0',
          '@media (min-width: 600px)': {
            minWidth: 40,
          },
          '&.Mui-selected': {
            color: textColor.primary,
            // color: primaryColor.main,
          },
          '& .MuiTab-wrapper': {
            display: 'block',
            // '&::first-letter': {
            //   textTransform: 'uppercase',
            // },
          },
        },
        textColorInherit: {
          color: textColor.secondary,
        },
      },
      MuiTooltip: {
        tooltip: {
          backgroundColor: bg.white,
          fontSize: fontSize.size13,
          fontWeight: 600,
          color: textColor.primary,
          fontFamily: TypofontFamily,
          boxShadow: `0 12px 24px 0 rgba(0, 0, 0, 0.10), 0 2px 6px 0 rgba(0, 0, 0, 0.10)`,
          '& .MuiTooltip-arrow': {
            color: bg.white,
          },
        },
      },
      MuiChip: {
        root: {
          minWidth: 50,
          height: 28,
          borderRadius: 0,
          fontSize: 12,
          fontWeight: 600,
          fontFamily: TypofontFamily,
          textTransform: 'initial',
          '&.text-success': {
            backgroundColor: otherColor.tagbg_green,
            color: otherColor.success,
          },
          '&.text-warning': {
            backgroundColor: otherColor.tagbg_yellow,
            color: otherColor.tag_yellow,
          },
          '&.text-danger': {
            backgroundColor: otherColor.tagbg_red,
            color: otherColor.tag_red,
          },
          '&.text-success2': {
            backgroundColor: otherColor.success2Bg,
            color: otherColor.success2,
          },
          '&.text-warn2': {
            backgroundColor: otherColor.warn2Bg,
            color: otherColor.warn2,
          },
          '&.text-primary': {
            backgroundColor: otherColor.tagbg_pink,
            color: otherColor.danger,
          },
          '&.text-secondary': {
            backgroundColor: otherColor.tagbg_gray,
            color: otherColor.tag_gray,
          },
          '&.text-info': {
            backgroundColor: otherColor.infoLight,
            color: otherColor.info,
          },
          '&.label-tag-1': {
            backgroundColor: otherColor.tagbg_magenta,
            color: otherColor.tag_magenta,
          },
          '&.label-tag-2': {
            backgroundColor: otherColor.tagbg_orange,
            color: otherColor.tag_orange,
          },
          '&.text-primaryWarning': {
            backgroundColor: primaryColor.primaryLight,
            color: textColor.primary,
          },
        },
      },
      MuiPaper: {
        root: {
          fontFamily: TypofontFamily,
          borderRadius: 0,
          '&.MuiPaper-elevation1': {
            border: `1px solid ${border.light}`,
          },
        },
        rounded: {
          borderRadius: 0,
        },
      },
      MuiAvatar: {
        colorDefault: {
          fontFamily: HeaderfontFamily,
          backgroundColor: bg.whiteOff2,
        },
      },
      MuiFormHelperText: {
        root: {
          fontFamily: TypofontFamily,
          fontSize: fontSize.size9,
          marginTop: 7,
          marginLeft: 12,
        },
      },
      MuiTableHead: {
        root: {
          backgroundColor: '#F3F1F0',
        },
        head: {
          color: textColor.primary,
        },
      },
    },
  };
}
